import api from "@/api/api-config";

export async function importFrisco(file) {
  let formData = new FormData();
  formData.append("file", file);
  return await api.post("settlement/import/frisco", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
}

export async function importAuchan(file) {
  let formData = new FormData();
  formData.append("file", file);
  return await api.post("settlement/import/auchan", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
}

export async function getByDriver(userId) {
  return await api.get(`settlement/${userId}`);
}

export async function getTemplate(project) {
  return await api.get(`settlement/template/${project}`, {
    responseType: "blob",
  });
}
